const isPromise = p => //$FlowExpectedError[method-unbinding]  !!!
!!p && typeof p === "object" && typeof p.then === "function";

export default isPromise;